import React from 'react';
import { useSelector } from 'react-redux';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import Subscription from './Subscriptions/Subscription';
import MembershipsSubscriptions from './Memberships/Memberships';
import DiscountOptions from './DiscountOptions/DiscountOptions';
import QuoteGroups from './QuoteGroups';
import QuoteProductImages from './QuoteProductImages';


const AccordionStyled = withStyles({
  root: {
    boxShadow: 'none',
    borderRadius: '4px',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
    '&:nth-child(odd) .MuiAccordionSummary-root': {
      background: '#F6F6F9'
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      color: '#103A99',
      background: '#F0F0FF',
      '& .MuiSvgIcon-root': {
        color: '#103A99'
      }
    },
    '&.Mui-expanded': {
      border: '1px solid rgba(16, 58, 153, 0.99)',
      borderRadius: '4px'
    }
  }
})(Accordion);

const configurationItems = (productData, subscriptionOptions) => {
  const isMembership = productData?.sku.includes('MEMBER');
  const title = isMembership ? `Membership Subscriptions (${subscriptionOptions.length})` : `Subscriptions (${subscriptionOptions.length})`;
  const description = isMembership ? 'Create or configure membership subscriptions here' : 'Create or configure subscriptions here';

  let existingValues = [];

  if (productData && productData.custom_attributes) {
    const { custom_attributes } = productData;
    const existingQuoteproDiscounts = custom_attributes.find((attr) => attr.attribute_code === 'quotepro_discounts');
    existingValues = existingQuoteproDiscounts?.value ? JSON.parse(existingQuoteproDiscounts.value) : [];
  }

  return [
    {
      title: 'Group',
      description: 'A listing can have one or several groups',
      component: <QuoteGroups />
    },
    {
      title: `Images (${productData?.media_gallery_entries?.length || 0})`,
      description: 'Upload images of your listing here',
      component: <QuoteProductImages />
    },
    {
      title: `Discounts (${existingValues.length || 0})`,
      description: 'Create and configure your discount here',
      component: <DiscountOptions />
    },
    {
      title,
      description,
      component: isMembership ? <MembershipsSubscriptions /> : <Subscription />
    }
  ];
};

const QuoteConfigurationsContainer = () => {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const {
    editableQuoteProduct,
    quoteProductSubscriptionOptions
  } = useSelector((state: IReduxState) => state.quote);

  const handleChange = (panel: string) => (
    event: React.ChangeEvent<Record<string, unknown>>,
    newExpanded: boolean
  ) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <>
      {configurationItems(
        editableQuoteProduct,
        quoteProductSubscriptionOptions
      ).map(({title, description, component}, index) => {
        return (
          <>
            <AccordionStyled
              square
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}
              key={`panel${index}`}
            >
              <AccordionSummary
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                expandIcon={<ArrowDropDownCircleIcon />}
                className="py-2 px-5 border-radius-4"
              >
                <div>
                  <Typography variant="h5" className="mb-1">
                    {title}
                  </Typography>
                  <Typography variant="body1">{description}</Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                {component}
              </AccordionDetails>
            </AccordionStyled>
          </>
        );
      })}
    </>
  );
};

export default QuoteConfigurationsContainer;
